import { Flex } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Card, Input, PopConfirm, Spinner, Toast } from '@common-web';
import { setQuickLinks } from '@reducers/quick-links-slice/index.js';
import { deleteQuickLinkApi } from '@apis/seller-center/quick-links.js';
import { getErrorString } from '@utils/utils.js';

const QuickLinkDNDitems = ({ currentLink = {}, editEnabled = false, quickLinks = [] }) => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(currentLink.name);
  const [editMode, setEditMode] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  return (
    <Card
      styles={{
        body: {
          '--ant-padding-lg': 'var(--ant-padding-sm)',
          cursor: 'pointer',
        },
      }}
      bordered
    >
      <Flex align="center" justify="space-between" gap={12}>
        {editEnabled && editMode ? (
          <Input
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            containerClassName={'flexGrow'}
          />
        ) : (
          currentLink.name
        )}

        <Flex gap={4} className="flexShrink0">
          {editEnabled && editMode ? (
            <PopConfirm
              title={'Edit Quick Link'}
              onConfirm={() => {}}
              child={<Button icon={'MdCheck'} iconSize={16} type="link" />}
            />
          ) : (
            <>
              {editEnabled && (
                <Button
                  icon={'MdEdit'}
                  iconSize={16}
                  type="link"
                  onClick={(event) => {
                    setEditMode(true);
                  }}
                />
              )}
            </>
          )}
          <PopConfirm
            title={'Delete Saved Search'}
            onConfirm={async () => {
              try {
                setDeleteLoading(true);
                await deleteQuickLinkApi(currentLink.id);
                dispatch(setQuickLinks(quickLinks.filter((link) => link.id !== currentLink.id)));
              } catch (err) {
                Toast.error(getErrorString(err));
              } finally {
                setDeleteLoading(false);
              }
            }}
            child={
              deleteLoading ? (
                <Spinner size="small" color="red" fontSize={14} />
              ) : (
                <Button icon={'IoTrashSharp'} iconSize={16} type="link" />
              )
            }
          />
        </Flex>
      </Flex>
    </Card>
  );
};

export default QuickLinkDNDitems;
